module.exports = __webpack_public_path__ + "img/squash.73aa8c6a.svg";